import React from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import MyCard from '../components/MyCard';
import { useSelector } from 'react-redux';
import { Loading } from './Loading';
import ErrorPage from '../pages/ErrorPage';


function CardContainer(props) {
    const loading = useSelector(state => state.loading)
    const error = useSelector(state => state.error)

    if(loading) return <Loading/>
    if(error || props.movies === undefined ) return <ErrorPage/>

    return (
        <>
            <Row md={1} className="justify-content-center m-1">
                <Badge variant="info" className="pt-3"><h4> { props.title } </h4>
                </Badge>
            </Row>
            <Row xs={2} md={3}>
                {
                    props.movies.map((movie) => {
                        return (
                            <Col key={movie.id}><MyCard movie={movie}/></Col>
                        )
                    })
                }
            </Row>
        </>
    )
}

export default CardContainer